import { render, staticRenderFns } from "./qualityInspectionBi.vue?vue&type=template&id=6621b8e8"
import script from "./qualityInspectionBi.vue?vue&type=script&lang=js"
export * from "./qualityInspectionBi.vue?vue&type=script&lang=js"
import style0 from "./qualityInspectionBi.vue?vue&type=style&index=0&id=6621b8e8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports